export default "__VITE_ASSET__D1egUzML__"